export class FailedToGetCurrentUserDataError {

};
